import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view';

const regex = /<([^<>]*)>/g; // looking for `<something>` occurrences

function MarkushValue({ value = '', uid }) {
  const scrollTo = useCallback(
    (element) => {
      const escaped = element.replace(/['"$^]/g, (match) => `\\${match === '"' ? '&quot;' : match}`);
      scrollIntoView(`#${uid}-${escaped}`, { behavior: 'smooth', align: { top: -25 }, time: 300 });
    },
    [uid]
  );

  const transformValue = (val) =>
    val.split(regex)?.map((part, index) =>
      index % 2 === 1 ? (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,react/no-array-index-key
        <a key={index} onClick={() => scrollTo(part)}>
          {part}
        </a>
      ) : (
        part
      )
    );

  return value ? <>{transformValue(value)}</> : null;
}

MarkushValue.propTypes = {
  value: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
};

export default MarkushValue;
